import React, { forwardRef } from 'react';
import ControllerError from './controller-error';
import ErrorBoundary from './error-boundary';
import { useFormViewerContext } from './form-viewer-context';
import Widget from './widget';
const FormViewerLean = /*#__PURE__*/ forwardRef(({ i18n, formId, stepId, values, onChange, onBlur, onFocus, onStepIdChange, errors, onValidate, onError, externalData, overrides, bi, biFormFillSessionId, forcedState, onSubmit, onSubmitSuccess, onSubmitFailure, fields, RicosViewer, panorama, PortalContainer }, forwardedRef)=>{
    const { host, controller } = useFormViewerContext();
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        host: host,
        wfConfig: controller.wfConfig,
        onError: onError
    }, /*#__PURE__*/ React.createElement(ControllerError, {
        wfConfig: controller.wfConfig,
        onError: onError
    }, /*#__PURE__*/ React.createElement(Widget, {
        i18n: i18n,
        bi: bi,
        biFormFillSessionId: biFormFillSessionId,
        formId: formId,
        values: values,
        stepId: stepId,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        onStepIdChange: onStepIdChange,
        errors: errors,
        onValidate: onValidate,
        forwardedRef: forwardedRef,
        controller: controller,
        onError: onError,
        externalData: externalData,
        overrides: overrides,
        forcedState: forcedState,
        fields: fields,
        RicosViewer: RicosViewer,
        onSubmit: onSubmit,
        onSubmitSuccess: onSubmitSuccess,
        onSubmitFailure: onSubmitFailure,
        panorama: panorama,
        PortalContainer: PortalContainer
    })));
});
export default FormViewerLean;

//# sourceMappingURL=form-viewer-lean.js.map